
(function () {
    'use strict';

    angular.module('thankview.video', ['thankview.global', 'thankview.recorder'])
        .controller('VideoController', ['$scope', '$rootScope', '$timeout', '$document', '$window', function ($scope, $rootScope, $timeout, $document, $window) {
            console.log('video controller loaded');
            $scope.playlist = null;
            $scope.playlistCurrentVideo = null; // index of the currently loaded video in the playlist
            $scope.init = function () {
                if (!config.params) {
                    $timeout($scope.init(), 100);
                    return;
                }

                if (config.params.past_reports) {
                    $scope.past_reports = config.params.past_reports;
                }

                // if this project has a playlist, we want to display it and add controls
                if (config.params.project && config.params.project.playlist) {
                    $scope.playlist = config.params.project.playlist;
                    $scope.playlistCurrentVideo = $scope.playlist.splice(0, 1)[0]; // the video currently playing, initally first video in list

                    const playerCont = $document[0].querySelector('.player-container');
                    const cardBack = $document[0].querySelector('.card-back');

                    $scope.choosePlaylistVideo = ($event, index) => {
                        // ensure player is reset
                        playerCont.classList.remove('shrink');
                        playerCont.classList.remove('watched');
                        cardBack.classList.remove('flip-back-message-visible');

                        // first, hold on to currently playing video, soon to be "previous video"
                        const prevVideo = $scope.playlistCurrentVideo;
                        // next, set the current video to the one just clicked
                        $scope.playlistCurrentVideo = $scope.playlist[index];
                        // set previous video in the old video's spot
                        $scope.playlist[index] = prevVideo;

                        $rootScope.$broadcast('switch-video', $scope.playlistCurrentVideo);
                        $scope.scrollToTop();

                        if (typeof gtag === 'function') {
                            gtag('event', 'thankview example', { video: $scope.playlistCurrentVideo.slug });
                        }
                    };
                }

                $scope.openIntercomChat = function ($event, prefillMessage = null) {
                    // ensure Intercom has loaded, i.e. not blocked behind an ad blocker
                    if ($document[0].getElementById('intercom-frame')) {
                        Intercom('showNewMessage', prefillMessage);
                    } else {
                        // failed to load intercom, send email instead
                        const emailSubject = 'Question About ThankView';
                        const emailTo = 'sdr@thankview.com';
                        const emailLink = angular.element('<a/>');
                        emailLink.attr({
                            href: `mailto:${emailTo}?subject=${emailSubject}`,
                        })[0].click();
                    }
                };

                $scope.scrollToTop = () => {
                    let scrollBehavior = 'smooth'; // prefer smooth scrolling
                    // if user has indicated prefers reduced motion, don't animate
                    const mediaQuery = $window.matchMedia('(prefers-reduced-motion: reduce)');
                    if (mediaQuery.matches) {
                        scrollBehavior = 'auto';
                    }

                    const supportsNativeSmoothScroll = 'scrollBehavior' in $document[0].documentElement.style;

                    if (supportsNativeSmoothScroll) {
                        $window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: scrollBehavior,
                        });
                    } else {
                        $window.scrollTo(0, 0);
                    }
                };

                const params = new URLSearchParams($window.location.search);
                $scope.showEnvelope = params.get('type') === 'envelope';
            };

            $scope.init();
        }]);
}());
